import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

axios.interceptors.response.use(
  response => {
    // intercept the global error
    return response;
  },
  function(error) {
    if (error.response.status === 401) {
      // if the error is 401 and hasent already been retried
      window.location.href = "/api/auth";
    }
    if (error.response.status === 404) {
      window.location.href = "/";
      return;
    }
    // Do something with response error
    return Promise.reject(error);
  }
);

const store = new Vuex.Store({
  state: {
    records: [],
    record: {},
    agreements: [],
    correspondences: [],
    agencies: [],
    record_states: [],
    agreement: {},
    correspondence: {},
    session: {},
    document: {},
    embed_ready: true,
    embed_loading: false,
    variables: {}
  },
  mutations: {
    setSession(state, payload) {
      state.session = payload;
    },
    setRecords(state, payload) {
      state.records = payload;
    },
    setAgreement(state, payload) {
      state.agreement = payload;
    },
    setCorrespondence(state, payload) {
      state.correspondence = payload;
    },
    setEmbedReady(state, ready) {
      state.embed_ready = ready;
    },
    setEmbedLoading(state, ready) {
      state.embed_loading = ready;
    },
    setAgreements(state, payload) {
      state.agreements = payload;
    },
    setCorrespondences(state, payload) {
      state.correspondences = payload;
    },
    setRecord(state, record) {
      state.record = record;
    },
    setRecordStates(state, payload) {
      state.record_states = payload;
    },
    setVariables(state, payload) {
      state.variables = payload;
    },
    setAgencies(state, payload) {
      state.agencies = payload;
    }
  },
  actions: {
    loadRecord({ commit }, record) {
      axios
        .get("/api/record", { params: { id: record.id } })
        .then(function(response) {
          commit("setRecord", response.data);
        });
    },
    loadVariables({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get("/api/variables").then(
          response => {
            // http success, call the mutator and change something in state
            commit("setVariables", response.data);
            resolve(response); // Let the calling function know that http is done. You may send some data back
          },
          error => {
            // http failed, let the calling function know that action did not work out
            reject(error);
          }
        );
      });
    },
    loadAgencies({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get("/api/agencies").then(
          response => {
            // http success, call the mutator and change something in state
            commit("setAgencies", response.data);
            resolve(response); // Let the calling function know that http is done. You may send some data back
          },
          error => {
            // http failed, let the calling function know that action did not work out
            reject(error);
          }
        );
      });
    },
    setVariables({ commit }, variables) {
      return new Promise((resolve, reject) => {
        axios.post("/api/variables", variables).then(
          response => {
            // http success, call the mutator and change something in state
            commit("setVariables", response.data);
            resolve(response); // Let the calling function know that http is done. You may send some data back
          },
          error => {
            // http failed, let the calling function know that action did not work out
            reject(error);
          }
        );
      });
    },
    loadRecords({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get("/api/records").then(
          response => {
            commit("setRecords", response.data);
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    loadRecordStates({ commit }) {
      axios.get("/api/recordstates").then(function(response) {
        commit("setRecordStates", response.data);
      });
    },
    loadAgreement({ commit }, agreement) {
      return new Promise((resolve, reject) => {
        axios.get("/api/agreement", { params: agreement }).then(
          response => {
            // http success, call the mutator and change something in state
            commit("setAgreement", response.data);
            resolve(response); // Let the calling function know that http is done. You may send some data back
          },
          error => {
            // http failed, let the calling function know that action did not work out
            reject(error);
          }
        );
      });
    },
    loadCorrespondence({ commit }, correspondence) {
      return new Promise((resolve, reject) => {
        axios.get("/api/correspondence", { params: correspondence }).then(
          response => {
            // http success, call the mutator and change something in state
            commit("setCorrespondence", response);
            resolve(response); // Let the calling function know that http is done. You may send some data back
          },
          error => {
            // http failed, let the calling function know that action did not work out
            reject(error);
          }
        );
      });
    },
    embedReady({ commit }, ready) {
      commit("setEmbedReady", ready);
    },
    embedLoading({ commit }, ready) {
      commit("setEmbedLoading", ready);
    },
    loadAgreements({ commit }) {
      axios.get("/api/agreements").then(function(response) {
        commit("setAgreements", response.data);
      });
    },
    loadCorrespondences({ commit }) {
      axios.get("/api/correspondences").then(function(response) {
        commit("setCorrespondences", response.data);
      });
    },
    createRecord({ commit }, record) {
      return new Promise((resolve, reject) => {
        axios.post("/api/record/create", record).then(
          function(response) {
            commit("setRecord", record);
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    updateRecord({ commit }, record) {
      return new Promise((resolve, reject) => {
        axios.post("/api/record", record).then(
          function(response) {
            commit("setRecord", record);
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    removeRecord({ commit }, data) {
      commit;
      return new Promise((resolve, reject) => {
        axios.delete("/api/record", { params: data }).then(
          function(response) {
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    loadSession({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get("/api/session").then(
          response => {
            commit("setSession", response.data);
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    uploadAgreement({ commit }, obj) {
      return new Promise((resolve, reject) => {
        axios.post("/api/agreements/upload", obj).then(
          response => {
            commit("setAgreement", response.data);
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    uploadCorrespondence({ commit }, obj) {
      return new Promise((resolve, reject) => {
        axios.post("/api/correspondences/upload", obj).then(
          response => {
            commit("setCorrespondence", response.data);
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
      });
    }
  },
  getters: {
    record: state => {
      if (Object.keys(state.record).length === 0) {
        return null;
      } else {
        return state.record;
      }
    }
  }
});

export default store;
